<div class="program-content">
  <!--  <h2 class="mat-display-2">Programm</h2> -->
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>

  <div class="content-page">
    <mat-toolbar class="admin-nav">
      <ul class="nav">
        <li *ngFor="let category of categories">
          <a
            mat-button
            (click)="filterCategory(category.id)"
            routerLink="/category-course/{{ category.id }}"
            >{{ category.name }}</a
          >
        </li>
      </ul>
    </mat-toolbar>

    <div class="courses">
      <mat-grid-list
        [cols]="breakpoint"
        [gutterSize]="'10'"
        rowHeight="32rem"
        (window:resize)="onResize($event)"
      >
        <mat-grid-tile *ngFor="let course of courses">
          <mat-card class="example-card" routerLink="/courses/{{ course.id }}">
            <div>
              <div>
                <mat-card-header style="padding: 16px 0px 0px 0px !important">
                  <div class="course-title">
                    <mat-card-title>{{ course.title }}</mat-card-title>
                  </div>

                  <div class="properties">
                    <div>
                      <p class="label">Wann:</p>
                      <p class="value">
                        {{ course.start_date | date }} -
                        {{ course.end_date | date }}<br />
                        {{ course.days }}
                      </p>
                    </div>
                    <div>
                      <p class="label">U-Std.:</p>
                      <p class="value">{{ course.duration }}</p>
                    </div>
                    <!-- <div>
                                            <p class="label">Tage und Uhrzeit:</p>
                                            <p class="value">
                                                {{course.days }} 
                                            </p>
                                        </div> -->
                    <div>
                      <p class="label">Kursgebühr:</p>
                      <p class="value">
                        {{ course.course_fees | currency : "EUR" }}
                      </p>
                    </div>
                    <!-- <div>
                                            <p class="label">Adresse:</p>
                                            <p class="value">{{ course.location }}</p>
                                        </div> -->
                    <!-- <div>
                                            <p class="label">Leitung:</p>
                                            <p class="value">{{ course.lead }}</p>
                                        </div> -->
                    <div>
                      <p class="label">Kurs-Nr:</p>
                      <p class="value">{{ course.code }}</p>
                    </div>
                    <div class="location">
                      <p class="label">Wo:</p>
                      <p class="value">{{ course.location }}</p>
                    </div>
                  </div>
                </mat-card-header>
              </div>
              <div>
                <mat-card-content
                  style="
                    padding: 0px 5px 0px 10px !important;
                    display: flex;
                    align-items: flex-end;
                  "
                >
                  <p>
                    {{ course.content }}
                  </p>
                </mat-card-content>
              </div>
            </div>

            <mat-card-actions>
              <button mat-button>{{ course.director }}</button>
            </mat-card-actions>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
        (page)="OnPageChange($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </div>
  </div>
</div>
